import React from "react"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { useFrontendConfig } from "../../FrontendConfig"
import { useCustomerInfo } from "../../CustomerInfo"

export const FooterCopyright = () => {
  const { BuildDatetime } = useFrontendConfig()
  const { i18n } = useTranslations()
  const { data } = useCustomerInfo()

  const version = process.env.NODE_ENV !== "development"
    ? BuildDatetime?.slice(0, 10)
    : new Date().getMilliseconds()

  const year = new Date().getFullYear()


  const text = (() => {
    if (data?.customerName === "ISSO") {
      return i18n("General:PoweredByCirrusGeneric").replace("{0}", String(version))
    }

    return i18n("General:PoweredByCirrus")
      .replace("{1}", String(data?.customerName))
      .replace("{0}", String(version))
  })()

  return (
    <Text className="cirrus-copyright-text">
      <div dangerouslySetInnerHTML={{ __html: text }}>
      </div>
      <div>
        {i18n("General:CopyrightText2").replace("{0}", String(year))}
      </div>
    </Text>
  )
}

const Text = styled("div")(({ theme }) => ({
  color: "#333",
  textAlign: "center",
  fontSize: "12px",
  gridColumn: "1 / -1",
  gridRow: 3,
  alignSelf: "end",
  padding: "16px 24px",

  [theme.breakpoints.down("md")]: {
    order: 4,
    alignSelf: "center",
  },

  // "a, a:visited, a:hover, a:active, a:focus": {
  //   color: "#333",
  //   textDecoration: "none"
  // },

  "> div::first-letter": {
    textTransform: "capitalize",
  }
}))
